<template>
  <div>
    <el-button
      style="position: absolute;"
      plain
      type="single-number"
      @click="showDialogTreeTable"
    >
      选择物资
    </el-button>
    <el-dialog-tree-table
      @handleTrue="dialogTreeTableTrue"
      :dialogFormVisible.sync="dialogTreeTableVisible"
    ></el-dialog-tree-table>
  </div>
</template>

<script>
export default {
  name: "materials",
  data() {
    return {
      dialogTreeTableVisible: false
    };
  },
  methods: {
    showDialogTreeTable() {
      this.dialogTreeTableVisible = true;
    },
    dialogTreeTableTrue(data) {
      alert(JSON.stringify(data));
      this.$emit("dialogTreeTableTrue", data);
    }
  }
};
</script>

<style scoped></style>
